export const PHONE_NUMBER = '6592 0428';
export const EMAIL = 'arceip@autism.org.sg';
